import React from 'react';
import styled from 'styled-components';
import { RowDiv, Text, theme } from 'styles';
import { Icon } from './Icon';

export function InfoDiv({ children, $alignItems, $paddingTop }) {
  return (
    <Info $alignItems={$alignItems || 'center'}>
      <Icon name="Light" $paddingTop={$paddingTop} />
      <Text $type="m18" $color="assistive">
        {children}
      </Text>
    </Info>
  );
}

const Info = styled(RowDiv)`
  margin-top: 32px;
  border-radius: 8px;
  padding: 4px 8px;
  gap: 8px;
  background-color: ${theme.colors.gray100};
`;
